const g = ({
  size: e,
  isRounded: t,
  bgColor: r,
  disabled: n
}) => ({
  base: "inline-flex items-center justify-center gap-1.5 font-medium transition ease-in-out",
  size: e === "sm" ? "text-sm py-2 px-2.5 leading-4" : "text-base py-2.5 px-3 leading-5",
  rounded: t ? "rounded-full px-4" : "rounded-md",
  disabled: n ? "opacity-50 cursor-not-allowed pointer-events-none" : "",
  bgColor: {
    primary: "bg-neteera-teal-200 text-gray-900 hover:bg-neteera-teal-300",
    white: "bg-white text-grey-600",
    dark: "bg-grey-600 text-white",
    blue: "bg-blue-200 text-grey-600",
    yellow: "bg-yellow-200 text-grey-600",
    green: "bg-green-200 text-grey-600",
    red: "bg-red-200 text-grey-600",
    transparent: "bg-none text-grey-600"
  }[r ?? "primary"]
}), i = (e) => e === "sm" ? { width: 16, height: 16 } : { width: 20, height: 20 };
export {
  i as getIconSize,
  g as getTagStyles
};
